import { Box, styled } from "@mui/material";

interface DataBoxProps {
  responsive?: boolean;
}

export const DataBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'responsive',
})<DataBoxProps>(({ theme, responsive = false }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: responsive ? 0 : '200px',
  gap: theme.spacing(0.5),
  flex: responsive ? '1 1 auto' : undefined,
  overflow: responsive ? 'hidden' : undefined,
}));
